<template>
<div class="chapter">
<div class="inner_page">
<p class="toc-title"><span>Contents</span></p>
<p class="toc-text"><span><a href="#/xhtml/frontmatter01">Author’s Preface</a></span></p>
<p class="toc-text1"><span><a href="#/xhtml/chapter001">Wig</a></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter002" title="Link target outside of Sample">Dressing Up In Voices</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter003" title="Link target outside of Sample">A Slight Chill</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter004" title="Link target outside of Sample">Borneo</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter005" title="Link target outside of Sample">Paint</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter006" title="Link target outside of Sample">Other Men’s Sweetness</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter007" title="Link target outside of Sample">Wheee!</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter008" title="Link target outside of Sample">Old Boys</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter009" title="Link target outside of Sample">The List</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter010" title="Link target outside of Sample">Choking</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter011" title="Link target outside of Sample">Dangerous Pleasures</span></span></p>
<p class="toc-text1"><span><span href="#/xhtml/author" title="Link target outside of Sample">About the Author</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?50153e4e